export const SET_SAVED_JOBS = 'SET_SAVED_JOBS'
export const SET_STATS = 'SET_STATS'
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS'